import React, { useContext, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import Modal from '../ui/Modal';
import SvgButton from '../ui/SvgButton';

interface GamePaperMakingDescriptionProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onFinish: () => void;
}

function GamePaperMakingDescription(props: GamePaperMakingDescriptionProps) {
  const { playClick } = useContext(AudioContext);
  const [status, setStatus] = useState<'message' | 'intro' | ''>('message');

  const ShowMessage = () => {
    return <div className="modal modal-game-paper-making game-message">
      <button className="button modal-button-close" onClick={() => { playClick(); setStatus(''); props.onFinish(); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-paper-making/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
      </button>
      <div className="modal-content">
        <p className="message">使用竹簡紀載書寫實在太麻煩了，<br />我要研究方法去製作一種簡單方便的材料紀載書寫才行！</p>
      </div>
      <button className="button modal-button-next" onClick={() => { playClick(); setStatus('intro'); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-paper-making/game1-next-button`} src1=".svg" src2="-select.svg" alt="下一頁"></SvgButton>
      </button>
    </div>
  }
  const ShowIntro = () => {
    return <div className="modal modal-game-paper-making game-intro">
      <button className="button modal-button-close" onClick={() => { playClick(); setStatus(''); props.onFinish(); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-paper-making/close-button`} src1=".svg" src2="-select.svg" alt="關閉"></SvgButton>
      </button>
      <div className="modal-content">
      </div>
      <button className="button modal-button-next" onClick={() => { playClick(); setStatus(''); props.onFinish(); }}>
        <SvgButton prefix={`${process.env.PUBLIC_URL}/assets/game-paper-making/game1-next-button`} src1=".svg" src2="-select.svg" alt="下一頁"></SvgButton>
      </button>
    </div>
  }

  return (
    <>
      {'' !== status
        ? <Modal>
          {'message' === status
            ? <ShowMessage />
            : <ShowIntro />}
        </Modal>
        : null}
    </>
  )
}

export default GamePaperMakingDescription;
